import useSWR from 'swr';
import { useCallback } from 'react';
import ActivitiesIdentifyGetIdentifyInfo from '@quickService/ActivitiesIdentifyGetIdentifyInfo';
import { UpdateModal } from '@tencent/calendar-web-component-pc-biz';
import dayjs from 'dayjs';
import { Button, Modal } from '@tencent/tea-component';
import { useRouter } from 'next/router';

/** 实名身份认证逻辑 */
const useNameAuth = () => {
  const router = useRouter();
  const { data, error, mutate, isValidating } = useSWR(
    {
      url: '/v2/activities/identify/get-identify-info',
    },
    async () => {
      const data = await ActivitiesIdentifyGetIdentifyInfo().then((res) => {
        if (res.code === 0) {
          return res.data;
        }
        return Promise.reject(res.msg);
      });
      return {
        deadline: data.deadline,
        b_identify: data.b_identify,
      };
    },
    {
      revalidateOnFocus: false,
    },
  );
  const identify = data?.b_identify;
  const deadline = data?.deadline || NaN;

  const deadlineDate = dayjs(deadline * 1000);
  // const deadlineDate = dayjs(deadline * 1000).add(9, 'days');
  const before7 = deadlineDate.subtract(7, 'days');
  // 到达ddl前一周后，开始强提示，到达截止日期后不提示了
  const showModalTip = before7.isBefore(dayjs()) && deadlineDate.isAfter(dayjs());

  // 到达截止时间，无法发布
  const isOver = deadlineDate.isBefore(dayjs());

  // 前往认证
  const gotoAuth = useCallback(() => {
    router.push('/name-auth');
  }, []);

  // 发布前先检查是否实名认证和是否到达截止日期
  const checkNameAuth = useCallback(() => {
    if (identify === false && isOver) {
      const closeModal = UpdateModal.show({
        className: 'name-auth-modal-publish',
        title: '请完成身份认证',
        children: (
          <div>
            <Modal.Body>
              根据有关法律法规和平台服务规则规定，为了保障您的账号安全，防范安全风险，需完成身份认证后才能发布活动。
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="weak"
                onClick={() => {
                  closeModal();
                }}
              >
                取消
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  closeModal();
                  gotoAuth();
                }}
              >
                前往认证
              </Button>
            </Modal.Footer>
          </div>
        ),
      });
      return false;
    }
    return true;
  }, [identify, isOver, gotoAuth]);

  return {
    data,
    error,
    mutate,
    isValidating,
    identify,
    deadline,
    showModalTip,
    checkNameAuth,
    isOver,
    gotoAuth,
    deadlineText: deadlineDate.format('YYYY-MM-DD HH:mm:ss'),
  };
};

export default useNameAuth;
